var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("polygon",{"points":"0 40 1.41 41.41 22.11 20.71 1.41 0 0 1.41 19.3 20.72 0 40"})));
}

Chevron.defaultProps = {"viewBox":"0 0 22.11 41.41"};

module.exports = Chevron;

Chevron.default = Chevron;
